import signedFetch from './util/signedFetch.js';

/**
 * This takes activation code as input and soft deletes ot
 * activationcode - Integer
 */
export default body => signedFetch('deleteActivationCode', `${__API_BASE__}/rbac/delete-act-code`, 'DELETE', body);
